import { render } from "./AI.vue?vue&type=template&id=39f1a596&scoped=true&ts=true"
import script from "./AI.vue?vue&type=script&lang=ts"
export * from "./AI.vue?vue&type=script&lang=ts"

import "./AI.vue?vue&type=style&index=0&id=39f1a596&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f1a596"]])

export default __exports__